// Wishlist curation: drag-drop filing + inline icon-button actions.
// - Update rows (in wish cards and the Uncategorized rail) are draggable; wish
//   cards are drop targets (assign/reassign) and the rail unlinks.
// - Summary-level icon buttons (edit / dismiss / restore / delete on wishes,
//   dismiss / delete-branch on updates) confirm then POST.
// Everything POSTs to the same handlers, then reloads — status/points/progress
// are derived server-side by the roll-up, so a reload always shows the truth.
// Armed only when the server rendered data-wishlist (curators), so viewers get
// no affordances. Uses the shared window.DragDrop component.

(function initWishlist() {
  // Icon-button actions -> POST target + confirm copy. wish-edit is local-only
  // (opens the card and reveals the inline rename form).
  var ACTS = {
    'wish-dismiss': { path: '/dismiss', field: 'wish_id',
      confirm: 'Dismiss this wish? It moves to Dismissed; its work orders keep their status.' },
    'wish-restore': { path: '/restore', field: 'wish_id',
      confirm: 'Restore this wish? Its status re-derives from its work orders.' },
    'wish-delete': { path: '/delete', field: 'wish_id',
      confirm: 'Delete this wish? Its work orders fall back to Unfiled.' },
    'upd-dismiss': { path: '/dismiss-update', field: 'update_id',
      confirm: 'Dismiss this work order? Its branch stays in the repo until you delete it.' },
    'branch-delete': { path: '/delete-branch', field: 'update_id',
      confirm: 'Delete this branch from the repo? This removes the branch on GitHub and this work order with it.' }
  };

  function boot() {
    var root = document.querySelector('.wl-cols[data-wishlist]');
    if (!root || !window.DragDrop) return;
    var base = root.getAttribute('data-base');
    var csrf = root.getAttribute('data-csrf');
    if (!base || !csrf) return;

    function post(path, field, id) {
      var body = new URLSearchParams();
      body.set('_csrf', csrf);
      body.set(field, id);
      return fetch(base + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      });
    }

    // One delegated listener for every icon button. preventDefault keeps a
    // button inside <summary> from also toggling its <details>.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-wl-act]') : null;
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      var act = btn.getAttribute('data-wl-act');
      var id = btn.getAttribute('data-id');

      if (act === 'wish-edit') {
        var card = btn.closest('.wl-card');
        var panel = root.querySelector('[data-wl-edit-panel="' + id + '"]');
        if (card && panel) {
          card.open = true;
          panel.hidden = !panel.hidden;
          if (!panel.hidden) {
            var first = panel.querySelector('input[name="title"]');
            if (first) first.focus();
          }
        }
        return;
      }

      var spec = ACTS[act];
      if (!spec || !window.confirm(spec.confirm)) return;
      post(spec.path, spec.field, id).then(function () { window.location.reload(); });
    });

    window.DragDrop.initDraggable({
      container: '.wl-cols[data-wishlist]',
      itemSelector: '[data-update-id]',
      idAttr: 'data-update-id',
      ghostText: function (n) { return n === 1 ? '1 work order' : n + ' work orders'; }
    });

    // wishId '' => unlink (the assign handler treats a blank wish_id as NULL).
    function assign(ids, wishId) {
      var posts = ids.map(function (id) {
        var body = new URLSearchParams();
        body.set('_csrf', csrf);
        body.set('update_id', id);
        body.set('wish_id', wishId);
        return fetch(base + '/assign', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        });
      });
      Promise.all(posts).then(function () { window.location.reload(); });
    }

    // The wish card an update currently sits in, or null if uncategorized.
    // Matched by class, not [data-wish-id]: Declined cards drop that attribute
    // (they are not drop targets) but their updates must still be draggable OUT.
    function cardOf(id) {
      var el = root.querySelector('[data-update-id="' + id + '"]');
      return el ? el.closest('.wl-card') : null;
    }

    root.querySelectorAll('.wl-card[data-wish-id]').forEach(function (card) {
      window.DragDrop.makeDropZone(card, {
        hoverClass: 'wl-drop-hover',
        onDrop: function (ids) {
          // Skip updates already on this wish (same-wish drop is a no-op).
          var moved = ids.filter(function (id) { return cardOf(id) !== card; });
          if (moved.length) assign(moved, card.getAttribute('data-wish-id'));
        }
      });
    });

    var rail = root.querySelector('[data-wl-unfile]');
    if (rail) {
      window.DragDrop.makeDropZone(rail, {
        hoverClass: 'wl-drop-hover',
        onDrop: function (ids) {
          // Only unlink updates that are currently on a wish.
          var moved = ids.filter(function (id) { return !!cardOf(id); });
          if (moved.length) assign(moved, '');
        }
      });
    }
  }

  // Bulk approval. The form posts normally; this only keeps the button honest
  // about how many are selected and stops an empty submit.
  function bootApprove() {
    var form = document.querySelector('.wl-approve[data-wl-approve]');
    if (!form) return;
    var boxes = Array.prototype.slice.call(form.querySelectorAll('input[name="update_ids"]'));
    var submit = form.querySelector('[data-wl-approve-submit]');
    var all = form.querySelector('[data-wl-approve-all]');
    if (!boxes.length || !submit) return;

    function sync() {
      var n = boxes.filter(function (b) { return b.checked; }).length;
      submit.disabled = n === 0;
      submit.textContent = n === 0 ? 'Approve selected'
        : (n === 1 ? 'Approve 1 work order' : 'Approve ' + n + ' work orders');
      if (all) {
        all.textContent = (n === boxes.length) ? 'Clear selection' : 'Select all';
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'update_ids') sync();
    });
    if (all) {
      all.addEventListener('click', function () {
        var target = boxes.some(function (b) { return !b.checked; });
        boxes.forEach(function (b) { b.checked = target; });
        sync();
      });
    }
    sync();
  }

  // Drag-to-reorder. Separate from the filing drag above, and the two are told
  // apart by TARGET, not by modifier: a drop inside the list you started in
  // reorders; a drop onto a different wish card, or the rail, files. That is
  // why the reorder handlers sit on the <ul>/<details> containers and call
  // stopPropagation — the filing drop zones are their ancestors, so without it
  // every reorder would also register as a re-file onto the same wish.
  //
  // What is being dragged has to be tracked in a variable rather than read
  // from dataTransfer: browsers deny getData() during dragover for security,
  // and dragover is exactly where the decision has to be made.
  function bootSortable() {
    var root = document.querySelector('.wl-cols[data-wishlist]');
    if (!root) return;
    var base = root.getAttribute('data-base');
    var csrf = root.getAttribute('data-csrf');
    if (!base || !csrf) return;

    var drag = null;   // { el, kind, list }

    function listOf(el) { return el && el.closest ? el.closest('[data-sortable-list]') : null; }
    function kindOf(list) { return list ? list.getAttribute('data-sortable-list') : null; }

    // Wish cards are <details>. DragDrop.initDraggable only marks update rows,
    // so the cards are armed here.
    root.querySelectorAll('.wl-card[data-sortable]').forEach(function (card) {
      card.setAttribute('draggable', 'true');
    });

    root.addEventListener('dragstart', function (e) {
      var item = e.target.closest ? e.target.closest('[data-sortable]') : null;
      if (!item) { drag = null; return; }
      var list = listOf(item);
      if (!list) { drag = null; return; }
      drag = { el: item, kind: kindOf(list), list: list };
      item.classList.add('wl-dragging');
      // Let the filing drag keep working for update rows: DragDrop's own
      // dragstart also fires and populates dataTransfer.
      if (drag.kind === 'wish') {
        try { e.dataTransfer.setData('text/plain', 'wish:' + item.getAttribute('data-wish-id')); } catch (_) {}
        e.dataTransfer.effectAllowed = 'move';
      }
    });

    root.addEventListener('dragend', function () {
      if (drag && drag.el) drag.el.classList.remove('wl-dragging');
      drag = null;
    });

    // The element to insert before: the first sibling whose vertical midpoint
    // is below the pointer. Midpoint rather than top edge, so the swap happens
    // when the cursor passes the halfway mark and the list does not flicker
    // back and forth on a one-pixel move.
    function insertBefore(list, y) {
      var items = Array.prototype.slice.call(list.children)
        .filter(function (c) { return c.matches('[data-sortable]') && c !== drag.el; });
      for (var i = 0; i < items.length; i++) {
        var box = items[i].getBoundingClientRect();
        if (y < box.top + box.height / 2) return items[i];
      }
      return null;
    }

    // CAPTURE PHASE, on each list, and this is load-bearing rather than a
    // stylistic choice.
    //
    // The filing drop zones from makeDropZone() are bound directly to the wish
    // CARDS. A wish card is a descendant of the wish list, so during bubbling
    // the card's filing listener runs BEFORE anything bound higher up — a
    // delegated reorder handler on the container calls stopPropagation() only
    // after filing has already claimed the drop. That is exactly what happened:
    // the rows visibly reordered and nothing was ever saved, because the drop
    // went to the filing zone and the reorder never got it.
    //
    // Binding per-list in the capture phase inverts the order. The list sees
    // the event first, and when it is a same-list reorder it stops the event
    // there, so the card's filing listener never runs. When it is not, the
    // handler returns without stopping and filing proceeds untouched.
    root.querySelectorAll('[data-sortable-list]').forEach(function (list) {
      list.addEventListener('dragover', function (e) {
        // Only the list the drag started in. Anything else is a file, not a
        // reorder, and belongs to the drop zone underneath.
        if (!drag || list !== drag.list) return;
        e.preventDefault();
        e.stopPropagation();
        var ref = insertBefore(list, e.clientY);
        if (ref !== drag.el) list.insertBefore(drag.el, ref);
      }, true);

      list.addEventListener('drop', function (e) {
        if (!drag || list !== drag.list) return;
        e.preventDefault();
        e.stopPropagation();
        persist(list);
      }, true);
    });

    function persist(list) {
      var kind = kindOf(list);
      var attr = kind === 'wish' ? 'data-wish-id' : 'data-update-id';
      var ids = Array.prototype.slice.call(list.querySelectorAll('[data-sortable]'))
        .map(function (el) { return el.getAttribute(attr); })
        .filter(Boolean);
      if (!ids.length) return;

      var body = new URLSearchParams();
      body.set('_csrf', csrf);
      body.set('kind', kind);
      body.set('ids', ids.join(','));
      if (kind === 'update') body.set('wish_id', list.getAttribute('data-wish') || '');

      list.classList.add('wl-saving');
      fetch(base + '/reorder', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).then(function (r) {
        list.classList.remove('wl-saving');
        // A failed save leaves the page showing an order the server does not
        // have. Reload rather than let the two drift apart silently.
        if (!r.ok) window.location.reload();
      }).catch(function () { window.location.reload(); });
    }
  }

  function bootAll() {
    boot();
    bootApprove();
    bootSortable();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
